import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const warehouseAPI = {
    create: async (warehouseData) => {
        try {
            const { data } = await api.post('/api/warehouses/create/', warehouseData);
            return data;
        } catch (error) {
            handleApiError(error, 'Create warehouse error:');
        }
    },
    getAll: async (page, pageSize, searchTerm, showDeactivated) => {
        try {
            const { data } = await api.get('/api/warehouses', {
                params: { page, pageSize, searchTerm, showDeactivated }
            });
            return data;
        } catch (error) {
            handleApiError(error, 'Get all warehouses error:');
        }
    },
    getById: async (id) => {
        try {
            const { data } = await api.get(`/api/warehouses/${id}`);
            return data;
        } catch (error) {
            handleApiError(error, 'Get warehouse by id error:');
        }
    },
    update: async (id, warehouseData) => {
        try {
            const { data } = await api.put(`/api/warehouses/update/${id}/`, warehouseData);
            return data;
        } catch (error) {
            handleApiError(error, 'Update warehouse error:');
        }
    },
    delete: async (id) => {
        try {
            const { data } = await api.delete(`/api/warehouses/delete/${id}/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Delete warehouse error:');
        }
    }
};